export class NotificationCount{

    public count: number;
    constructor(){}
  
    deserialize(input){
      this.count = input.count;
      return this;
    }
  }